import { render, staticRenderFns } from "./PaymentSearchMenu.vue?vue&type=template&id=ff0face8"
import script from "./PaymentSearchMenu.vue?vue&type=script&lang=js"
export * from "./PaymentSearchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports